// this is the sample data of the three prices tables which is icd, cpt, drug
const samplePriceData = {
    icd_file: [
      ['icdcode', 'cost', 'discount'],
      ['I63.9',    100,   10],
      ['I10',      200,   20],
      ['N40.1',    150,   50],
      ['I63.113',  250,   10],
      ['C50.819',  300,   30],
      ['C49.A2',   400,   25],
      ['B17.11',   50,    5],
      ['H91.21',   600,   10],
      ['C16.1',    500,   20],
      ['R51',      80,    50],
      ['D28.2',    251,   1],
      ['E32.8',    275,   8],
      ['F13.14',   257,   17],
      ['G57.73',   472,   30],
      ['J01.11',   374,   17],
      ['K13.6',    107,   14],
      ['L74.8',    249,   28],
      ['M13.111',  344,   7],
      ['O36.1924', 313,   28],
      ['P28.9',    275,   9],
      ['Q43.2',    339,   10],
      ['S01.341D', 188,   18],
    ],
    cpt_file: [
      ['cptcode', 'cost', 'discount'],
      ['01926',  600, 10],
      ['71046',  200, 20],
      ['81405',  150, 50],
      ['88309',  300, 30],
      ['00731',  80,  50],
      ['D8693',  486, 11],
      ['V2020',  233, 13],
      ['15821',  367, 18],
      ['64553',  314, 22],
      ['70130',  465, 9],
      ['A0998',  186, 2],
      ['C1719',  171, 35],
      ['E0973',  467, 9],
      ['G9299',  305, 31],
      ['J3489',  116, 31],
      ['L0810',  363, 8],
      ['Q4029',  433, 20],
      ['S9117',  229, 25],
    ],
    drug_file: [
      ['product_id', 'cost', 'discount'],
      ['824640',  80,  50],
      ['1248',    500, 20],
      ['221',     600, 10],
      ['502943',  50,  5],
      ['796643',  400, 25],
      ['4050',    300, 30],
      ['31324',   250, 10],
      ['14566',   250, 10],
      ['896099',  150, 50],
      ['2234',    100, 10],
      ['10223',   200, 20],
      ['830050',  90,  10],
      ['494903',  280, 25],
      ['2',       113, 16],
      ['8340',    112, 31],
      ['11611',   285, 17],
      ['13346',   242, 18],
      ['24775',   443, 27],
      ['33355',   469, 11],
      ['834350',  389, 11],
    ['923094', 154, 35],
  ],
  pharmacy_drug_file: [
    ['product_id', 'quantity', 'price',],
    ['2', 100, 25.50],
    ['3', 150, 15.75,],
    ['4', 200, 10.00,],
    ['5', 300, 20.00,],
    ['6', 250, 18.50,],
  ]
};

export default samplePriceData